import Vue from 'vue';
import { captureException as sentryCaptureException, addBreadcrumb, Severity } from '@sentry/browser';
import bus from '@/plugins/bus';

const production = process.env.VUE_APP_ENVIRONMENT === 'production';

function errorToString(strOrObj) {
  if (typeof strOrObj === 'string') {
    return strOrObj;
  }

  let result = '';

  if (strOrObj.messages) {
    result += strOrObj.messages.join(', ');
  }

  if (strOrObj.message) {
    if (result.length > 0) {
      result += ', ';
    }

    result += strOrObj.message;
  }

  if (strOrObj.field) {
    return `${strOrObj.field}: ${result}`;
  }

  return result;
}

// Always displays error.
// parses optional array argument.
// input allows:
// 'simple error'
// ['kaas, is baas', 'echt', 'waar']
// [{ message: 'kaas, is baas' }, { message: 'echt' }, { message: 'waar' }]
function formatErrors(errors) {
  let message = errors;

  if (!errors || errors.length === 0) {
    return null;
  }

  if (errors.forEach) {
    message = errors
      .filter(v => !!v)
      .map(errorToString)
      .join(' - ');
  }

  return message;
}

function captureException(exception) {
  if (!production) {
    throw exception;
  } else {
    sentryCaptureException(exception);
  }
}

function log(message, category = 'debug') {
  const stringMessage = typeof message === 'string' ? message : JSON.stringify(message);
  bus.$emit('log', stringMessage);

  if (!production) {
    console.info(message);
  } else {
    console.info(message);
    const level = Severity.Debug;
    addBreadcrumb({ category, message: stringMessage, level });
  }
}

Vue.prototype.$captureException = captureException;
Vue.prototype.$log = log;

export {
  captureException, log, errorToString, formatErrors,
};
